import { type FC, type ReactNode, type MouseEventHandler } from "react";
import { Starfield, StarfieldToggle } from "./Starfield";
import styles from "./ScryShell.module.css";

export const ScryOrb: FC = () => (
  <svg viewBox="0 0 100 100" width="64" height="64" aria-hidden="true">
    <circle fill="currentColor" cx="50" cy="48" r="30" />
    <path
      d="M31,39 A23,23 0 0 1 45,25"
      stroke="var(--scry-paper, #f4efe2)"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />
    <path
      fill="currentColor"
      d="M35,76 L65,76 L72,90 L28,90 Z M13,14 l2.5,6.5 6.5,2.5 -6.5,2.5 -2.5,6.5 -2.5,-6.5 -6.5,-2.5 6.5,-2.5 Z M86,30 l2,5 5,2 -5,2 -2,5 -2,-5 -5,-2 5,-2 Z"
    />
    <circle fill="currentColor" cx="79" cy="12" r="2.5" />
  </svg>
);

export const ScryWordmark: FC<{
  onHomeClick?: MouseEventHandler<HTMLAnchorElement>;
}> = ({ onHomeClick }) => (
  <span className={styles.brand}>
    <a href="/" onClick={onHomeClick} aria-label="Scry home">
      <ScryOrb />
      <span>scry</span>
    </a>
    <span aria-hidden="true">.</span>
    <a href="https://wzrdz.cool" target="_blank" rel="noreferrer">
      wzrdz.cool
    </a>
  </span>
);

export const ScryShell: FC<{
  children: ReactNode;
  headerActions?: ReactNode;
}> = ({ children, headerActions }) => (
  <div className={styles.shell}>
    <Starfield />
    <header className={styles.header}>
      <ScryWordmark />
      {headerActions && (
        <div className={styles.headerActions}>{headerActions}</div>
      )}
    </header>
    <main className={styles.main}>{children}</main>
    <footer className={styles.footer}>
      <span>
        Powered by Element Call · <a href="/scry-source.tar.gz">Source code</a>
        <StarfieldToggle separator />
      </span>
    </footer>
  </div>
);
